import React from 'react';
import {HashRouter} from 'react-router-dom';
import {StylesProvider} from '@material-ui/core';
import {RecoilRoot} from "recoil";
import Layout from "./pages/Layout";

const App: React.FC = () => {
    return (
      <RecoilRoot>
        <StylesProvider injectFirst>
            <HashRouter>
               <Layout />
            </HashRouter>
        </StylesProvider>
      </RecoilRoot>
    );
}

export default App;
